<template>
    <v-card class="rounded-4"> 
        <v-toolbar flat height="45px">  
            <b>Automated Attendance Reminder Emails</b>
            <v-spacer></v-spacer>  
            <v-btn icon @click.native="closeDialog()" >
            <v-icon>close</v-icon>
            </v-btn>                      
        </v-toolbar>

        <v-card-text>

            <!-- employee and trans data -->
            <v-layout row wrap class="ml-25 mb-10">
                <v-flex xs12 sm4>
                    <div class="caption grey--text text--darken-3 mt-10">Employee</div>
                    <v-chip class="user-chip-container font-weight-bold">
                        <v-avatar>
                            <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(data.userId)"></v-img>
                        </v-avatar>
                        {{data.firstName}} {{data.lastName}}
                    </v-chip>
                </v-flex>
                <v-flex xs12 sm4>
                    <div class="caption grey--text text--darken-3 mt-10">Trans Date</div>
                    <v-chip class="user-chip-container font-weight-bold">
                        {{ param.transDate | moment('MMM DD, YYYY')}}
                    </v-chip>
                </v-flex>
                <v-flex xs12 sm4>
                    <div class="caption grey--text text--darken-3 mt-10">Workshift</div>
                    <v-chip v-if="param.workShift" :style="`background-color:${param.workShiftColor};`" class="user-chip-container font-weight-bold">
                        {{$moment(param.clockStart).format('h:mma')}} - {{$moment(param.clockEnd).format('h:mma')}}
                    </v-chip>
                </v-flex>
            </v-layout>
            
            <!-- attendance reminders data -->
            <v-data-table
                :headers="headers"
                :items="data.reminders"
                :loading="loading"
                :hide-headers="isMobile"
                hide-actions
            >
                <template v-slot:items="props">

                    <!-- mobile view -->
                    <tr v-if="isMobile">
                        <td :colspan="headers.length" class="pa-1">
                            <v-card class="elevation-1">
                                <v-toolbar flat height="42">
                                    <b>{{ getReminderTypeDescription(props.item.reminderType) }}</b>
                                    <v-spacer></v-spacer>
                                </v-toolbar>

                                <v-layout row wrap align-center class="section-layout">
                                    <v-flex xs12 class="text-xs-left mt-5 mb-5">

                                        <!-- Sent To -->
                                        <v-layout row class="text-xs-left mt-5 mb-5">
                                            <v-flex xs12>
                                                <div class="caption grey--text text--darken-2">Sent To</div>
                                                <div>{{ props.item.email }}</div>
                                            </v-flex>
                                        </v-layout>

                                        <!-- Sent On -->
                                        <v-layout row class="text-xs-left mt-5 mb-5">
                                            <v-flex xs12>
                                                <div class="caption grey--text text--darken-2">Sent On</div>
                                                <div>{{ props.item.sentOn | moment('MMM DD, YYYY h:mma') }}</div>
                                            </v-flex>
                                        </v-layout>

                                        <!-- Status -->
                                        <v-layout row class="text-xs-left mt-5 mb-5">
                                            <v-flex xs12>
                                                <div class="caption grey--text text--darken-2">Status</div>
                                                <div>
                                                    <span :class="commonfn.getStatusColor(props.item.status)">{{commonfn.getStatusDescription(props.item.status)}}</span>
                                                </div>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>

                            </v-card>
                        </td>
                    </tr>

                    <!-- desktop view -->
                    <tr v-else>
                        <td>
                            {{ getReminderTypeDescription(props.item.reminderType) }}
                        </td>
                        <td>{{ props.item.email }}</td>
                        <td>{{ props.item.sentOn | moment('MMM DD, YYYY h:mma') }}</td>
                        <td>
                            <span :class="commonfn.getStatusColor(props.item.status)">{{commonfn.getStatusDescription(props.item.status)}}</span>
                        </td>
                    </tr>
                </template>
            </v-data-table>

        </v-card-text>
    </v-card>
</template>
<script>

import attendanceRemindersApi from '@/api/attendancereminders'
import awsS3Helper from '@/helpers/aws-s3'
import commonfn from '@/common/functions'       //for refactor
import { getReminderTypeDescription } from '@/constants/reminder-types.js'

export default {
    data () {
        return {
            commonfn,
            awsS3Helper,
            error: false,
            errorMessage: null,
            loading: false,
            disabled: false,
            headers: [
                {text: 'Reminder Type', align: 'left', value: 'reminderType', width:'25%', sortable:true},
                {text: 'Sent To', align: 'left', value: 'email', width: '25%', sortable:true},
                {text: 'Sent On', align: 'left', value: 'sentOn', width: '30%', sortable:true},
                {text: 'Status', align: 'left', value: 'status', width: '20%', sortable:true}
            ],
            param: null,
            data: null
        }   
    },
    methods: {
        getReminderTypeDescription,
        async getAttendanceReminders(param) {
            try {
                this.loading = true
                this.param = param
                const response = await attendanceRemindersApi.getReminders(param.userId, this.$moment(param.transDate).format('YYYY-MM-DD'))      
                if (response && response.status == 200) {
                    this.data = response.data
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        closeDialog() {
            this.$emit('update:dialogAttendanceReminder', false)
        },
    },
}
</script>
<style scoped>
.section-layout {
    padding:0px 20px 0px 20px;
}
</style>